// extracted by mini-css-extract-plugin
export var actionIcon = "_sk-0";